<template>
  <div
    class="i-personality-type-home"
    @click="isLargeScreen ? goToPersonality() : null"
  >
    <iBaseHeader
      highlight-text=""
      text="Personality Type"
      font-size-text="16px"
      align="start"
    />
    <iBaseHeader
      :highlight-text="personalityType"
      text=""
      font-size-highlighted-text="32px"
      align="start"
    />
    <div class="bottom">
      <div class="info">{{ personalityDescription }}</div>
      <iBaseExpandableParagraph
        class="paragraph"
        :text="capboiAssessment"
        :text-size="descriptionFontSize"
        minified
        :collapsed-length="descriptionMaxlength"
      />
      <iBaseTextCta
        text="Read More"
        @cta-clicked="goToPersonality"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRouter } from "vue-router"
import { useReportStore } from "@/stores/report"
import { breakpointLg, breakpointMd, breakpointSm, breakpointXl } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"

import { GlobalVariables } from "@/helpers/globalVariables"

import iBaseHeader from "@/components/base/BaseHeader.vue"
import iBaseTextCta from "@/components/base/BaseTextCta.vue"
import iBaseExpandableParagraph from "@/components/base/BaseExpandableParagraph.vue"

// ROUTES
const router = useRouter()

// STORES AND COMPOSABLES
const reportStore = useReportStore()
const isMobileOrLarger = useIsScreenSize(breakpointSm)
const isTabletOrLarger = useIsScreenSize(breakpointMd)
const isLargeScreen = useIsScreenSize(breakpointLg)
const isXLargeScreen = useIsScreenSize(breakpointXl)

// COMPUTED
const personalityType = computed(
  () => reportStore.reportData?.results?.personalityType ?? "Your professional type will be determined soon..."
)
const personalityDescription = computed(
  () => reportStore.reportData?.results?.personalityDescription ?? "Your personality description is coming soon..."
)
const capboiAssessment = computed(
  () => reportStore.reportData?.results?.capboiText ?? "Your assessment is coming soon..."
)
const descriptionFontSize = computed(() => (isXLargeScreen.value ? "14px" : "16px"))
const descriptionMaxlength = computed(() =>
  isXLargeScreen.value ? 350 : isTabletOrLarger.value ? 550 : isMobileOrLarger.value ? 350 : 200
)

// FUNCTIONS
const goToPersonality = () => {
  router.push({ name: GlobalVariables.urls.report.children.personality.routeName })
}
</script>

<style scoped lang="scss">
.i-personality-type-home {
  @include flex(column, start, stretch, $gap: 15px);

  padding: 20px 20px 0;
  width: 100%;
  height: 100%;

  @media screen and (min-width: $breakpoint-lg) {
    cursor: pointer;
  }

  @media screen and (min-width: $breakpoint-xl) {
    padding: 20px;
    border-bottom: 1px solid $zumthor100;
    border-right: 1px solid $zumthor100;
  }

  .bottom {
    @include flex(column, start, stretch, $gap: 18px);

    height: calc(100% - 102px);
    padding-bottom: 20px;
    border-bottom: 1px solid $zumthor100;

    @media screen and (min-width: $breakpoint-xl) {
      padding-bottom: 0;
      border: none;
    }

    .info {
      color: $pickle-bluewood800;
      font-weight: 400;

      @include text-lg;

      @media screen and (min-width: $breakpoint-xl) {
        @include text-md;
      }
    }

    .paragraph {
      color: $pickle-bluewood800;
    }
  }
}
</style>
